import * as React from 'react';
import * as _ from 'lodash';
import BasicDialog, {BasicDialogProps} from 'cl-dialogs/BasicDialog';
import {Omit, withStyles} from '@material-ui/core';
import List from '@material-ui/core/List';
import Divider from '@material-ui/core/Divider';
import Scrollbars from '../../../shared/vendor/react-custom-scrollbars/src'; // need to move scrollbars out of the application - possibly move to material-ui
import SearchField from '../SearchField';
import SelectionDialogItem, {SelectionDialogItemProps} from './SelectionDialogItem';
import * as Fuse from 'fuse.js';
import {createStyles} from '@material-ui/core/styles';
import {WithStyles} from '@material-ui/core/styles/withStyles';

export interface SelectionDialogProps extends Omit<BasicDialogProps, 'text' | 'classes'> {
  items: SelectionDialogItemProps[];
  searchable?: boolean;
}

interface SelectionDialogState {
  search: string;
}

class SelectionDialog extends React.PureComponent<
  SelectionDialogProps & WithStyles<typeof styles>,
  SelectionDialogState
> {
  state = {
    search: '',
  };

  handleSearchChange = search => {
    this.setState({search});
  };

  render() {
    const {
      items,
      actions,
      open,
      searchable,
      classes: {scrollbarsContainer},
      ...props
    } = this.props;
    const {search} = this.state;
    return (
      <BasicDialog
        fullWidth
        disableEnforceFocus
        disableRestoreFocus
        cancel
        maxWidth="xs"
        content={
          <React.Fragment>
            {searchable ? (
              <SearchField
                id="cla-dialog-search"
                fullWidth
                onChange={this.handleSearchChange}
                value={search}
                label="Find attribute"
              />
            ) : (
              undefined
            )}
            <Scrollbars containerClassName={scrollbarsContainer} horizontalScroll={false}>
              <List>
                {items
                  ? _.map(
                      !_.isEmpty(search) ? new Fuse(items, {keys: ['label'], threshold: 0.3}).search(search) : items,
                      ({id, ...props}, index) => {
                        return <SelectionDialogItem id={id ? id : `cla-list-item-${index}`} key={index} {...props} />;
                      }
                    )
                  : items}
              </List>
            </Scrollbars>
            {actions ? (
              <React.Fragment>
                <Divider />
                <List>{actions}</List>
              </React.Fragment>
            ) : (
              undefined
            )}
          </React.Fragment>
        }
        open={open && !_.isEmpty(items)}
        {...props}
      />
    );
  }
}

const styles = theme =>
  createStyles({
    scrollbarsContainer: {
      height: `${theme.spacing(30)}px!important`,
    },
  });
export default withStyles(styles)(SelectionDialog);
